<template lang="pug">
  #grid-display
    slot
    component(:is="entity.blockType"
      v-for="entity in entities"
      :key="entities.id"
      :entity="entity"
    )
</template>

<script>
export default {
  props: {
    entities: { type: Array, required: true },
  },

  data() {
    return {}
  },

  computed: {},

  watch: {},

  methods: {},

  components: {
    InterestBlock: require('@/components/InterestBlock').default,
    PersonBlock: require('@/components/PersonBlock').default,
  },
}

/* Computed ---------------------------------------------------- */

/* Watch ------------------------------------------------------- */
/* Methods ----------------------------------------------------- */
</script>
